module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAA+ElEQVQ4T+3UMQrCMBQG4P+Bg6OgQmkzeAAFNxcHHbyBo4tHEHoHBRE8guDgFRyEurg5OLi7NOJQb1D6REGpadNoXc34kv9LSMIjaMZViCkDrjpNzG5ZyllajHRYIIQHoJOYZ15UpBz+seQN5L6zE1AsCdGKkyHznIia6jYMrAvAJF4/+P6uC4SP1wyEGABY6l7WWI+iXuV83jwwDyg0HGcFor4xqCwg5nlZytG9/PpnecA49IZ9e0IVSmCfgmlQKmYCdZAW04FZUCamgibIiD3BumW1q5fL1vRttC3IFExtQYFtj0Fk5QnHMwQcKXCcexOs/YoB2N8AvOl4d8nvkdsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/xia.png
// module id = JEAz
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37 111